import { ComponentProps } from 'react';

import { SpinnerLoader } from './Spinner';
import { AtomLoader } from './Atom';
import { DualRingLoader } from './DualRing';

import { BaseLoaderProps } from './types';

const LoaderMapping = {
  spinner: SpinnerLoader,
  atom: AtomLoader,
  dualRing: DualRingLoader,
};

type LoaderMapping = typeof LoaderMapping;

type LoaderType = keyof LoaderMapping;

type LoaderByType = { [Type in LoaderType]: ComponentProps<LoaderMapping[Type]> };

type LoaderProps<Type extends LoaderType = 'spinner'> = BaseLoaderProps & {
  children?: never;
  type?: LoaderType;
} & LoaderByType[Type];

/**
 * Traditional loading indication
 *
 * Choose a boxed-sized spinner-like loader to display quick on-going operations
 *
 * Check out <Skeleton /> for ui loading
 */
export function Loader<Type extends LoaderType = 'spinner'>({
  type = 'spinner',
  ...props
}: LoaderProps<Type>): JSX.Element {
  const Component = LoaderMapping[type];

  return <Component {...props} />;
}
